import { useCallback } from 'react';
import { track } from '../../redux/actions/analytics';
import { ErrorMessageDisplayedTrackingProps } from '../../types/analytics';
import useAppDispatch from '../use-app-dispatch';
import useRouteInteractProps from './use-route-interact-props';
import { ERROR_MESSAGE_DISPLAYED } from '../../constants/analytics';

/** KU
 *
 * Returns a set of error handlers. These handlers dispatch error-related redux
 * actions and automatically include routing information in their payloads
 * (e.g., {@link handleErrorDisplayedTrack}).
 */
export default function useErrorTrack() {
  const dispatch = useAppDispatch();
  const routeInteractProps = useRouteInteractProps();

  const handleErrorDisplayedTrack = useCallback(
    (props: ErrorMessageDisplayedTrackingProps) => {
      dispatch(track(ERROR_MESSAGE_DISPLAYED, { ...routeInteractProps, ...props }));
    },
    [routeInteractProps],
  );

  return {
    handleErrorDisplayedTrack,
  };
}
